import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as S from './styled'

const Modal = ({
    children,
    title,
    isVisible,
    close,
    buttons,
    className = '',
    bodyClassName = '',
    hideCloseButton = false,
}) => (
    <S.Modal>
        <div
            className={classNames('modal', {
                visible: isVisible,
            })}
            tabIndex="-1"
            role="dialog"
        >
            <div className={`modal-dialog ${className}`} role="document">
                <div
                    className="modal-content"
                    data-testid={`${title.toLowerCase().replaceAll(' ', '-')}-modal`}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        {!hideCloseButton && (
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={close}
                                data-testid={`close-${title.toLowerCase().replaceAll(' ', '-')}`}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        )}
                    </div>
                    <div className={`modal-body ${bodyClassName}`}>{children}</div>

                    {buttons && buttons.length > 0 && (
                        <div className="modal-footer">
                            {buttons.map((button, idx) => (
                                <button
                                    type="button"
                                    className={`btn ${button.type}`}
                                    onClick={button.action}
                                    key={idx}
                                    disabled={button.disabled}
                                    data-testid={`button-action_${button.text
                                        .toLowerCase()
                                        .replaceAll(' ', '-')}`}
                                >
                                    {button.text}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    </S.Modal>
)

Modal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            text: PropTypes.string.isRequired,
            action: PropTypes.func.isRequired,
        })
    ),
}

export default Modal
